/**
 * Created by one on 2016/10/26.
 */

export default {
  /**
   * 设置当前登录信息用户
   * @param dispatch
   */
  setMenuExpanded({commit},menuIndex,isExpanded){
    commit('SET_MENU_EXPANDED', menuIndex, isExpanded);
  },
  /**
   * 初始化store数据:导航树
   * @param dispatch
   */
  setSidebarByVuex({commit},val){
    commit('SET_SIDEBAR', val);
  },
  /**
   * 设置用户管理员信息
   * @param dispatch
   * @param userInfo
     */
  setUserInfoByVuex({commit},userInfo){
    if(location.hash.indexOf("session") == -1){
	  HttpRequest.get('/admin.php?method=admin.getMe').then((response) => {
		commit('SET_USER_INFO',response.data);
	  });
    }
  },
  setCurrentFashionMenuByVuex({commit}, menu){
    commit('SET_CURRENT_FASHION_MENU',menu);
  },
  /**
   * 设置菜单是否需要更新的标志量
   * @param dispatch
   * @param flag  true:更新
   */
  commitFashionMenuUpdate({commit}, flag){
    commit('COMMIT_FASHION_MENU_UPDATE',flag)
  },
  /**
   * 设置瀑布流是否需要更新的标志量
   * @param dispatch
   * @param flag  true:更新
   */
  commitWaterfallUpdate({commit}, flag){
    commit('COMMIT_WATERFALL_UPDATE',flag)
  },
  commitCollapseUpdate({commit}, flag){
    commit('COMMIT_COLLAPSE_UPDATE',flag)
  },
  /**
   * 计算动态页被圈选图片数量
   * @param dispatch
   * @param step
   */
  updateArticleImgCount({commit}, step){
    commit('UPDATE_ARTICLE_IMG_COUNT',step)
  },
}
